import { useState } from 'react';
import { setObjectProperty, extractEventValue } from '../utils/objects';

export function useFormState(state) {
	const [formState, setFormState] = useState(state);
	return {
		formState,
		setFormState,
		setFieldState:
			(field, projFn: any = null) =>
			e => {
				//set the data to obj param or the state data field if exiests or use state object if exists otherwise use empty object.
				let data = { ...formState };
				let val = extractEventValue(e);
				val = projFn ? projFn(val) : val;
				let mutated = setObjectProperty(data, field, val);
				if (mutated) {
					return setFormState(data);
				} else return false;
			}
	};
}

// checkModified = field => {
// 	let setValue = this.setFieldState(field);
// 	return e => {
// 		let val = e.target ? e.target.value || e.target.checked || null : e;
// 		setValue(e);

// 		if (!this.state.modified && val !== this.state.original[field]) this.setState({ modified: true });
// 		else {
// 			let newObj = Object.assign(this.state.data, { [field]: val });
// 			if (val === this.state.original[field] && isObjectsEqual(this.state.original, newObj))
// 				this.setState({ modified: false });
// 		}
// 		return true;
// 	};
// };
// checkModified = field => {
// 	let setValue = this.setFieldState(field);
// 	return e => {
// 		let val = e;
// 		if (e?.target) {
// 			if (e.target.checked !== null) {
// 				val = e.target.checked;
// 			} else if (e.target.value !== null) val = e.target.value;
// 			else val = '';
// 		}
// 		setValue(e);
// 		if (!this.state.modified && val !== this.state.original[field]) this.setState({ modified: true });
// 		else {
// 			let newObj = Object.assign(this.state.data, { [field]: val });
// 			if (val === this.state.original[field] && isObjectsEqual(this.state.original, newObj))
// 				this.setState({ modified: false });
// 		}
// 		return true;
// 	};
// };
